import { Button } from "@progress/kendo-react-buttons";
import { useVendorAuth, useVendorLogout } from "auth/VendorAuth/hooks";
import { selectVendorUser } from "auth/VendorAuth/vendorUserSlice";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { saveElementValuesAsync } from "store/rfiSlice";
import "../styles/rfi.css";
import Loading from "./Loading";

const LoginGovLogin = () => {
  const { loginInProgress, login } = useVendorAuth();
  //todo: not needed for this component. just used for testing api calls for now
  //const {data} = useVendorUserProfile({enabled: isAuthenticated});
  const user = useAppSelector(selectVendorUser);
  const dispatch = useAppDispatch();

  const { vendorLogOut } = useVendorLogout();

  //todo: this will cover the whole page?
  if (loginInProgress) return <Loading />;

  return (
    <>
      <Button
        className="rfi-header"
        fillMode="link"
        size="large"
        themeColor="primary"
        onClick={() => {
          window.open(
            "/RFI-Assistant-Vendor-Guide.pdf",
            "_blank",
            "noopener noreferrer"
          );
        }}
      >
        User Guide
      </Button>
      {!user?.isAuthenticated && (
        <Button
          className="rfi-header"
          fillMode="link"
          size="large"
          themeColor="primary"
          onClick={() => {
            login();
          }}
        >
          Sign In
        </Button>
      )}
      {user?.isAuthenticated && (
        <Button
          className="rfi-header"
          fillMode="link"
          size="large"
          themeColor="primary"
          onClick={() => {
            dispatch(saveElementValuesAsync()).finally(() => {
              vendorLogOut();
            });
          }}
        >
          Sign Out
        </Button>
      )}
    </>
  );
};

export default LoginGovLogin;
